export default __webpack_public_path__ + "static/media/zaabeel.b1c058b0.webp";